import {isValueStringBetween} from './isValue'
import {ServerId} from '@colonist/types'

export class ValidationError extends Error {
    readonly value: unknown

    constructor(message: string, value: unknown) {
        super(message)
        this.value = value
    }
}

export function checkValueIsStringBetween(value: unknown, minLength: number, maxLength: number, errorMessage: string = 'Value is not a valid string'): string {
    if(!isValueStringBetween(value, minLength, maxLength)) {
        throw new ValidationError(errorMessage, value)
    }

    return value as string
}

const validServerIdRE = /^[a-z\d]{4,20}$/i
export function checkValueIsServerId(value: unknown, errorMessage: string = 'Value is not a valid server id'): ServerId {
    if(!validServerIdRE.test(value as string)) {
        throw new ValidationError(errorMessage, value)
    }

    return value as ServerId
}

const validMQTopicPartRE = /^[a-z]{2,20}$/i
export function checkValueIsMQTopicPart(value: unknown, errorMessage: string = 'Value is not a valid MQ topic part'): string {
    if(!validMQTopicPartRE.test(value as string)) {
        throw new ValidationError(errorMessage, value)
    }

    return value as string
}
